// src/context/AuthContext.jsx

import React, { useState, useEffect, createContext } from 'react';
import axios from '../api/axios'; // ✅ shared instance

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);


  const login = async (email, password) => {
  try {
     await axios.post('/api/auth/login', { email, password });
    // console.log('[LOGIN RESPONSE]', res.data);

    const { data } = await axios.get('/api/auth/me');
    // console.log('[ME RESPONSE]', data);

    setUser(data);
    return data;
  } catch (err) {
    console.error('Login error:', err);
    throw err;
  }
};



  const logout = async () => {
  try {
    await axios.post('/api/auth/logout');
  } catch (err) {
    console.warn('Logout error (session probably expired):', err.message);
  } finally {
    setUser(null);
  }
};

useEffect(() => {
  axios.get('/api/auth/me')
    .then((res) => setUser(res.data))
    .catch((err) => {
      // If it's just 401, user is anonymous; don’t redirect here.
      if (err.response?.status !== 401) {
        console.error('Auth check error:', err);
      }
      setUser(null);
    });
}, []);


  // useEffect(() => {
  //   axios.get('/api/auth/me')
  //     .then((res) => setUser(res.data))
  //     .catch(() => setUser(null));
  // }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};


